import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
  color: #aaaaaa;
  cursor: pointer;
`

// TODO Remove the onClick!
const Edit2 = ({ onClick, title = 'Edit', ...rest }: IconProps & { onClick?: () => void }) => (
  <StyledIcon onClick={onClick} viewBox="0 0 16 16" title={title} {...rest}>
    <path
      d="M15.173 2.8L12.96.587c-.24-.24-.587-.4-.933-.4a1.25 1.25 0 0 0-.934.4L.613 11.013c-.026.027-.053.054-.053.08v.08L.027 15.44c0 .08.026.16.08.213.026.054.08.08.16.08h.026L4.56 15.2h.08c.027 0 .053-.027.08-.053l8-8 1.6-1.6.853-.854c.24-.24.4-.586.4-.933 0-.347-.16-.72-.4-.96zM2.027 14.987l-1.28-1.28.24-1.947 2.96 2.96-1.92.267zm8.026-8.934l-6.4 6.4a.242.242 0 0 1-.186.08.242.242 0 0 1-.187-.08.258.258 0 0 1 0-.373l6.4-6.4a.258.258 0 0 1 .373 0 .258.258 0 0 1 0 .373zm2.48.507L9.173 3.2 10.4 1.973l3.36 3.36-1.227 1.227z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledIcon>
)

Edit2.displayName = 'Edit2'
Edit2.needsWork = true
export default Edit2
